import { Chip, Grid, Typography } from '@mui/material';

import { RatingOptions } from '../../app/launchDarkly/types';
import { RATING_OPTIONS } from './CookingHistoryEdit';
import styles from "./RecipeFeedbackEdit.module.css";

const RecipeFeedbackEdit = ({ rating, ratingOptions, selectedFeedback, handleFeedbackToggle, disabledEditing }: {
    rating: number,
    ratingOptions: RatingOptions,
    selectedFeedback: string[],
    handleFeedbackToggle: (feedback: string) => void,
    disabledEditing: boolean,
}) => (
    <Grid className={styles.mainContainer}>
        <Grid item xs={12}>
            <Typography variant="caption3Bold">Tell us more about it?</Typography>
        </Grid>
        <Grid className={styles.chipsContainer} item xs={12}>
            {ratingOptions[RATING_OPTIONS[rating]]?.options?.map((feedback: string) => (
                <Chip
                    className={selectedFeedback.includes(feedback) ? styles.selectedChip : styles.chip}
                    clickable
                    disabled={disabledEditing}
                    key={feedback}
                    label={feedback}
                    onClick={() => handleFeedbackToggle(feedback)}
                />
            ))}
        </Grid>
    </Grid >
);

export default RecipeFeedbackEdit;